import React from 'react';

import { IconProps, StyledPath, StyledSvg } from '../iconCommons';

export const IconFolderEmpty = ({ color = 'currentColor', size = 'xSmall', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" size={size} viewBox="0 0 16 16" {...props}>
        <StyledPath
            d="M13.5 6.5v-2a1 1 0 0 0-1-1h-7v-1a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v10.867a1.133 1.133 0 0 0 2.224.292L4.291 7.22a1 1 0 0 1 .962-.721H14.5a1 1 0 0 1 .967 1.257l-1.467 6a1 1 0 0 1-.967.743H1.631"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            color="none"
        />
    </StyledSvg>
);
